// @ts-strict-ignore
/**
 * @owner @Appboy/reporting
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/line_credit_consumption_detail_data" endpoint
 */
import { isLineConsumptionResult } from "@dashboardApi/apis/lineConsumption/validators";

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { lineConsumption } from "./constants";
import type { LineConsumptionParams, LineConsumptionResult } from "./types";

export const getDataTableLineConsumption = reactQueryTableFetcherAdapter(
  lineConsumption,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, sortby, sortdir, start = 0 }: LineConsumptionParams
  ): Promise<LineConsumptionResult> => {
    const { start_date, end_date, month, year, company, destination } = query;

    return fetch(
      `/analytics_dashboard/${appGroupId}/line_credit_consumption_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date: start_date,
        end_date: end_date,
        query: serializeQueryObjects({
          ...(month && { month }),
          ...(year && { year }),
          ...(company && { company }),
          ...(destination && { destination }),
        }),
      },
      { signal }
    );
  },
  isLineConsumptionResult
);
